document.addEventListener("DOMContentLoaded", () => {
  const joinUs = document.querySelector(".joinUs");
  let lastScroll = 0;

  if (!joinUs) return; // ← joinUsが存在しないときの安全処理

  window.addEventListener("scroll", () => {
    const currentScroll = window.scrollY;
    const viewportHeight = window.innerHeight;

    if (currentScroll > viewportHeight) {
      // 1画面以上スクロールしたら非表示
      joinUs.classList.add("is-hidden");
    } else if (currentScroll < lastScroll) {
      // スクロールを戻したら再表示
      joinUs.classList.remove("is-hidden");
    }

    lastScroll = currentScroll;
  });
});
